import theme from '../../../theme';

/**
 * Style object for the main Grid container.
 * Sets background, border radius, and padding using theme spacing.
 *
 * @type {import("@mui/system").SxProps}
 */
export const mainContainer = {
  height: 'calc(100vh - 92px)',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '1.5rem',
  padding: '1rem',
  justifyContent: 'space-between',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};
